import { unsafeCSS } from 'lit';

import { paletteDeclarations } from './tokens/theme.js';

export const nsColours = unsafeCSS(`:host {\n${paletteDeclarations()}\n\n  --ns-theme-font-family: 'Inter';\n}`);
